import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import ProductIntroduce from '@/components/ProductIntroduce'
import CooperationCase from '@/components/CooperationCase'
import News from '@/components/News'
import Aboutus from '@/components/Aboutus'
import PersonalInformationProtectionPolicy from '@/components/personalInformationProtectionPolicy'
import SpecifiedCommercialTransactions from '@/components/specifiedCommercialTransactions'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/product_introduce',
      name: 'productIntroduce',
      component: ProductIntroduce
    },
    {
      path: '/cooperation_case',
      name: 'cooperationCase',
      component: CooperationCase
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: Aboutus
    },
    {
      path: '/personal_information_protection_policy',
      name: 'personalInformationProtectionPolicy',
      component: PersonalInformationProtectionPolicy
    },
    {
      path: '/specified_commercial_transactions',
      name: 'specifiedCommercialTransactions',
      component: SpecifiedCommercialTransactions
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js